/** API base path (proxied by Vite in dev, Nginx in prod) */
export const API_BASE = "/api/v1";

/** Order statuses with Russian labels */
export const ORDER_STATUSES: Record<string, { label: string; color: string }> = {
  booked: { label: "Забронирован", color: "bg-blue-100 text-blue-800" },
  booking_ending: { label: "Заканч. бронь", color: "bg-orange-100 text-orange-800" },
  delivered: { label: "Выдан", color: "bg-green-100 text-green-800" },
  cancelled: { label: "Отменён", color: "bg-red-100 text-red-800" },
  returned: { label: "Возвращён", color: "bg-violet-100 text-violet-800" },
};

/** Publish batch statuses */
export const BATCH_STATUSES: Record<string, { label: string; color: string }> = {
  draft: { label: "Черновик", color: "bg-gray-100 text-gray-800" },
  scheduled: { label: "Запланирован", color: "bg-blue-100 text-blue-800" },
  publishing: { label: "Публикуется", color: "bg-yellow-100 text-yellow-800" },
  published: { label: "Опубликован", color: "bg-green-100 text-green-800" },
  failed: { label: "Ошибка", color: "bg-red-100 text-red-800" },
  cancelled: { label: "Отменён", color: "bg-gray-100 text-gray-600" },
};

/** Active order statuses (shown on "Active" tab). */
export const ACTIVE_STATUSES = new Set(["booked", "booking_ending"]);

/** History order statuses (shown on "History" tab). */
export const HISTORY_STATUSES = new Set(["delivered", "cancelled", "returned"]);

/** Default debounce delay for search inputs (ms). */
export const DEBOUNCE_DELAY_MS = 300;

/** User roles */
export const ROLES: Record<string, string> = {
  user: "Пользователь",
  seller: "Продавец",
  admin: "Администратор",
};

/** Moderation statuses */
export const MODERATION_STATUSES: Record<string, { label: string; color: string }> = {
  pending: { label: "На модерации", color: "bg-amber-100 text-amber-800" },
  approved: { label: "Одобрен", color: "bg-green-100 text-green-800" },
  rejected: { label: "Отклонён", color: "bg-red-100 text-red-800" },
};

